import React from 'react'
import AltNav from '../components/AltNav.js';

const Flashroom = () => {
    return (
        <div>
            <AltNav />
            <div className='work-alt-header-bg'></div>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('images/flashroom.png')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">FlashRoom</span>
                            <span class="stroke-text">FlashRoom</span>
                        </div>

                        <h2>FILE SHARING PLATFORM</h2>
                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>Instant File Sharing Platform</p>

                        <ul>
                            <li>Built with React, Node.js, and Socket.IO</li>
                            <li>FlashRoom is a real-time collaboration and file-sharing platform designed for classrooms, teams, and quick project sharing</li>
                            <li>Users can create a room and invite others instantly using a simple join code</li>
                            <li>It supports sharing code snippets, text documents, links, and uploaded files all in one place</li>
                            <li>Folders and downloadable ZIP packages make it easy to distribute starter projects to students or collaborators</li>
                            <li>Powered by AWS infrastructure, including Lightsail and S3 for scalable hosting and storage</li>
                            <li>Designed to make sharing and collaboration feel fast, simple, and seamless</li>
                            <li>Feel free to explore the platform and try creating your own room</li>
                        </ul>
                        <a href='https://flash-room.com' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                View Site
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='images/flashroom2.jpg' alt='flashroom file control' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />




                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>FlashRoom is a real-time collaboration and file-sharing platform I developed to make it easier for students, teachers, and teams to share code, documents, and project files instantly. Users can create a room, invite others through a simple join code, and immediately begin exchanging snippets, text content, links, and downloadable resources in one organized space. The platform supports folder structures and ZIP downloads for distributing full starter projects, making it especially useful in educational environments. Built with React, Node.js, and Socket.IO, and powered by AWS services like Lightsail and S3, FlashRoom is designed to feel fast, seamless, and modern while solving a real problem in classroom and collaborative workflows.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>

        </div>
    )
}

export default Flashroom
